import { render, staticRenderFns } from "./SelectMarketDialog.vue?vue&type=template&id=c87cf072"
import script from "./SelectMarketDialog.vue?vue&type=script&lang=js"
export * from "./SelectMarketDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports